'use strict';

module.exports = [
    {
        level: '1',
        code: '2135-2',
        label: 'Hispanic or Latino',
        definition: 'Hispanic or Latino'
    },
    { level: '2', code: '2137-8', label: 'Spaniard', definition: 'Spaniard' },
    {
        level: '3',
        code: '2138-6',
        label: 'Andalusian',
        definition: 'Andalusian'
    },
    { level: '3', code: '2139-4', label: 'Asturian', definition: 'Asturian' },
    {
        level: '3',
        code: '2140-2',
        label: 'Castillian',
        definition: 'Castillian'
    },
    {
        level: '3',
        code: '2141-0',
        label: 'Catalonian',
        definition: 'Catalonian'
    },
    {
        level: '3',
        code: '2142-8',
        label: 'Belearic Islander',
        definition: 'Belearic Islander'
    },
    { level: '3', code: '2143-6', label: 'Gallego', definition: 'Gallego' },
    { level: '3', code: '2144-4', label: 'Valencian', definition: 'Valencian' },
    { level: '3', code: '2145-1', label: 'Canarian', definition: 'Canarian' },
    {
        level: '3',
        code: '2146-9',
        label: 'Spanish Basque',
        definition: 'Spanish Basque'
    },
    { level: '2', code: '2148-5', label: 'Mexican', definition: 'Mexican' },
    {
        level: '3',
        code: '2149-3',
        label: 'Mexican American',
        definition: 'Mexican American'
    },
    { level: '3', code: '2150-1', label: 'Mexicano', definition: 'Mexicano' },
    { level: '3', code: '2151-9', label: 'Chicano', definition: 'Chicano' },
    { level: '3', code: '2152-7', label: 'La Raza', definition: 'La Raza' },
    {
        level: '3',
        code: '2153-5',
        label: 'Mexican American Indian',
        definition: 'Mexican American Indian'
    },
    {
        level: '2',
        code: '2155-0',
        label: 'Central American',
        definition: 'Central American'
    },
    {
        level: '3',
        code: '2156-8',
        label: 'Costa Rican',
        definition: 'Costa Rican'
    },
    {
        level: '3',
        code: '2157-6',
        label: 'Guatemalan',
        definition: 'Guatemalan'
    },
    { level: '3', code: '2158-4', label: 'Honduran', definition: 'Honduran' },
    {
        level: '3',
        code: '2159-2',
        label: 'Nicaraguan',
        definition: 'Nicaraguan'
    },
    {
        level: '3',
        code: '2160-0',
        label: 'Panamanian',
        definition: 'Panamanian'
    },
    {
        level: '3',
        code: '2161-8',
        label: 'Salvadoran',
        definition: 'Salvadoran'
    },
    {
        level: '3',
        code: '2162-6',
        label: 'Central American Indian',
        definition: 'Central American Indian'
    },
    {
        level: '3',
        code: '2163-4',
        label: 'Canal Zone',
        definition: 'Canal Zone'
    },
    {
        level: '2',
        code: '2165-9',
        label: 'South American',
        definition: 'South American'
    },
    {
        level: '3',
        code: '2166-7',
        label: 'Argentinean',
        definition: 'Argentinean'
    },
    { level: '3', code: '2167-5', label: 'Bolivian', definition: 'Bolivian' },
    { level: '3', code: '2168-3', label: 'Chilean', definition: 'Chilean' },
    { level: '3', code: '2169-1', label: 'Colombian', definition: 'Colombian' },
    {
        level: '3',
        code: '2170-9',
        label: 'Ecuadorian',
        definition: 'Ecuadorian'
    },
    {
        level: '3',
        code: '2171-7',
        label: 'Paraguayan',
        definition: 'Paraguayan'
    },
    { level: '3', code: '2172-5', label: 'Peruvian', definition: 'Peruvian' },
    { level: '3', code: '2173-3', label: 'Uruguayan', definition: 'Uruguayan' },
    {
        level: '3',
        code: '2174-1',
        label: 'Venezuelan',
        definition: 'Venezuelan'
    },
    {
        level: '3',
        code: '2175-8',
        label: 'South American Indian',
        definition: 'South American Indian'
    },
    { level: '3', code: '2176-6', label: 'Criollo', definition: 'Criollo' },
    {
        level: '2',
        code: '2178-2',
        label: 'Latin American',
        definition: 'Latin American'
    },
    {
        level: '2',
        code: '2180-8',
        label: 'Puerto Rican',
        definition: 'Puerto Rican'
    },
    { level: '2', code: '2182-4', label: 'Cuban', definition: 'Cuban' },
    { level: '2', code: '2184-0', label: 'Dominican', definition: 'Dominican' },
    {
        level: '1',
        code: '2186-5',
        label: 'Not Hispanic or Latino',
        definition:
            "Note that this term remains in the table for completeness, even though within HL7, the notion of 'not otherwise coded' term is deprecated."
    }
];
